{
    "feedData": {
        "09 Feb 2024": {
            "date": "09 Feb 2024",
            "description": "Hey folks, got a fun update to share! I've jazzed up the portfolio by swapping Vue.js for React, and wow, the difference is huge in terms of modularity, efficiency, and scalability. Exciting news: I've also plugged in Google's Gemini model for a snappy portfolio overview. 🚀 Oh, and I've given the UI a little facelift for an even better user experience. Go ahead and take a peek.",
            "hashtag": "#update #revamp",
            "pin": false
        },

        "08 Aug 2023": {
            "date": "08 Aug 2023",
            "description": "It took several attempts to get my portfolio to its current state, but I learned a lot along the way. With each iteration, I gained clarity and created something that truly represents my vision for the portfolio. Thanks for checking it out!",
            "image": "steve.webp",
            "hashtag": "#portfolio-journey",
            "pin": false
        }
    },

    "aboutData": {
        "basicInfo": {
            "description": "I'm Hari, a Software Engineer with 5+ years of experience specializing in front-end architecture and full-stack development. I've worked with leading companies like Chargebee and Worldline, building scalable web applications. Passionate about clean, maintainable code, I focus on translating business needs into innovative, user-centric solutions. I'm currently pursuing my Master's in Computing at Dublin City University (DCU).",
            "hashtag": "#about-me",
            "pin": false
        },

        "socials": {
            "description": "Reach Out!",
            "cards": {
                "gmail": "harisridhar77@gmail.com",
                "github": "github.com/hariof98/",
                "linkedin": "linkedin.com/in/hari-sridhar/",
                "medium": "medium.com/@hariof98/",
                "hashnode": "hashnode.com/@hariof98",
                "leetcode": "leetcode.com/u/hariof98/"
            },
            "hashtag": "#socials",
            "pin": false
        }
    },

    "experienceData": {
        "chargebee": {
            "highlights": {
                "name": "Chargebee",
                "role": "Associate Front-End Engineer",
                "duration": "Apr 2022 - Present"
            },
            "date": "08 Apr 2022",
            "filter": {
                "title": "Checkout The Projects",
                "param": "/projects/chargebee/"
            },
            "imageCover": "chargebee.png",
            "hashtag": "#fintech #subscription-management #recurring-billing #SaaS",
            "pin": false
        },

        "worldline": {
            "highlights": {
                "name": "Worldline",
                "role": "Full-Stack Developer",
                "duration": "Oct 2020 - Apr 2022"
            },
            "date": "05 Oct 2020",
            "filter": {
                "title": "Checkout The Projects",
                "param": "/projects/worldline/"
            },
            "imageCover": "worldline.png",
            "hashtag": "#fintech #pos #financial-transaction",
            "pin": false
        }
    },

    "skillsData": {
        "languages": {
            "description": "Languages",
            "points": ["JavaScript", "TypeScript", "PHP", "C"],
            "hashtag": "#languages"
        },

        "frameworks & libraries": {
            "description": "Frameworks & Libraries",
            "points": ["React", "React Native", "Redux", "Next.js", "Node.js", "Vue.js", "jQuery", "Laravel", "Laravel Zero", "Tailwind CSS"],
            "hashtag": "#frameworks&libraries"
        },

        "databases": {
            "description": "Databases",
            "points": ["SQL", "PostgreSQL"],
            "hashtag": "#databases"
        },

        "courseworks": {
            "description": "Courseworks",
            "points": ["Data Structures", "Algorithms", "System Design"],
            "hashtag": "#courseworks"
        },

        "platforms & services": {
            "description": "Platforms & Services",
            "points": ["AWS", "Vercel", "Linux"],
            "hashtag": "#platforms&services"
        },

        "tools": {
            "description": "Tools",
            "points": ["Webpack", "Parcel", "Vim", "Git", "Postman", "Elasticsearch", "Algolia", "CMS", "Storybook", "Figma"],
            "hashtag": "#tools"
        }
    },

    "educationData": {
        "dcu": {
            "highlights": {
                "name": "Dublin City University",
                "role": "Master's in Computing (Secure Software Engineering)",
                "duration": "2025 - 2026"
            },
            "hashtag": "#masters #software-engineering #dcu",
            "pin": false
        },

        "rit": {
            "highlights": {
                "name": "Rajalakshmi Institute of Technology",
                "role": "Bachelor of Computer Science",
                "duration": "2016 - 2020"
            },
            "hashtag": "#bachelors #computer-science #rit",
            "pin": false
        }
    },

    "projectsData": {
        "intro": {
            "description": "Below are the key projects that I have worked on, including projects for companies and personal projects. For a full list of open projects, do visit my GitHub page.",
            "link": {
                "feedLink": "https://github.com/hariof98/",
                "linkText": "GitHub"
            },
            "hashtag": "#projects #personal-projects #github",
            "showMore": false,
            "pin": false
        },

        "projectZero": {
            "description": "AI-Powered Web Page Companion",
            "subText": {
                "subTextOne": "Designed and developed an AI-powered widget for websites to enhance content consumption, enabling users to interact with and extract value from on-page content efficiently."
            },
            "link": {
                "feedLink": "https://github.com/hariof98/ai-web-widget",
                "linkText": "Personal Project"
            },
            "date": "01 May 2025",
            "hashtag": "#next.js #tailwind #openAI",
            "showMore": false,
            "pin": false
        },

        "projectOne": {
            "description": "AWS Pinpoint Implementation",
            "subText": {
                "subTextOne": "I played a key role in implementing SMS and Email alerts for customer and merchant transactions using AWS Pinpoint.",
                "subTextTwo": "This implementation proved effective in minimizing the overall cost of services by 20%, while also improving performance upto 40%.",
                "subTextThree": "Additionally, it eliminated the need to use multiple services for different processes, becoming a single source."
            },
            "link": {
                "feedLink": "https://docs.aws.amazon.com/pinpoint-email/latest/APIReference/Welcome.html",
                "linkText": "For Worldline"
            },
            "date": "12 Sep 2021",
            "hashtag": "#aws #pinpoint",
            "showMore": true,
            "pin": false
        },

        "projectTwo": {
            "description": "Memory Optimization",
            "subText": {
                "subTextOne": "During the rebranding process of Chargebee, there was an issue with the website. AWS code builds were failing due to the merging of old and new Git branches with two different versions of the code base. The garbage collector failed to complete its task due to a significant increase in memory space.",
                "subTextTwo": "The initial plan was to upgrade the infrastructure capacity to the next nearest plan, but that option was too expensive, costing 10x more than the current plan. To avoid switching to the costly plan, I worked around the issue and debugged the problem.",
                "subTextThree": "One significant problem was loading all the new components upfront, which was consuming around 20 to 30% of the total memory space, so I developed dynamic components, which allowed the components to load on demand on every page, preventing the components to load upfront. This improved the performance and loading time of the overall website and potentially prevented the company from paying around 200 USD per month."
            },
            "link": {
                "feedLink": "https://www.chargebee.com/",
                "linkText": "For Chargebee"
            },
            "date": "15 Jan 2023",
            "showMore": true,
            "hashtag": "#memory-management #memory-heap #optimization #JavaScript",
            "pin": false
        },

        "projectThree": {
            "description": "Chargebee Rebrand",
            "subText": {
                "subTextOne": "Played a key role in the rebranding of Chargebee's website by building components and micro-components, integrating the CMS with the existing codebase, and improving the existing architecture. These changes improved the website's scalability and performance and proved effective in accommodating the new implementations."
            },
            "link": {
                "feedLink": "https://www.chargebee.com",
                "linkText": "For Chargebee"
            },
            "date": "03 Nov 2022",
            "showMore": false,
            "hashtag": "#chargebee #rebrand #scaleup",
            "pin": false
        },

        "projectFour": {
            "description": "Bitcoin Order Book Application",
            "subText": {
                "subTextOne": "This is a real-time order book chart built using React, utilizing the Bitfinex API with WebSocket integration. This allows users to dynamically track buy and ask orders for enhanced trading insights on the cryptocurrency exchange."
            },
            "link": {
                "feedLink": "https://github.com/hariof98/bitcoin-order-book-app",
                "linkText": "Personal Project"
            },
            "date": "28 Dec 2023",
            "showMore": true,
            "hashtag": "#react #crypto #websocket",
            "pin": false
        },

        "projectFive": {
            "description": "GIF Search Mobile Application",
            "subText": {
                "subTextOne": "This application is built using React Native by leveraging Giphy's API. With this application, the user can search for the GIF'S they want and can also check different details of the GIF's."
            },
            "link": {
                "feedLink": "https://github.com/hariof98/gif-search-app",
                "linkText": "Personal Project"
            },
            "date": "02 Nov 2023",
            "showMore": true,
            "hashtag": "#react-native #mobile-app #gif",
            "pin": false
        },

        "projectSix": {
            "description": "Headless Commerce ROI Calculator",
            "subText": {
                "subTextOne": "Developed ROI Calculator for Headless Commerce to enable the business to identify the revenue impact on shifting to headless commerce."
            },
            "image": "roi-calculator.png",
            "link": {
                "feedLink": "https://www.chargebee.com/resources/tools/headless-commerce-roi-calculator",
                "linkText": "For Chargebee"
            },
            "date": "03 Nov 2022",
            "showMore": false,
            "hashtag": "#headless-commerce  #roi-calculator #revenue-impact",
            "pin": false
        }
    },

    "blogsData": {
        "intro": {
            "description": "During moments of boredom, I often find myself penning down my thoughts. Feel free to explore some of my blog articles below.",
            "hashtag": "#blogs #articles #medium #tech",
            "pin": false
        },

        "blogOne": {
            "description": "React? Really?",
            "image": "react-really.jpeg",
            "link": {
                "feedLink": "https://hariof98.hashnode.dev/really-react",
                "linkText": "Read the article"
            },
            "hashtag": "#react #frameworks #web-application",
            "date": "Dec 18 2023",
            "pin": true
        },

        "blogTwo": {
            "description": "The Story Of JavaScript",
            "image": "medium-post-js.jpg",
            "link": {
                "feedLink": "https://medium.com/@hariof98/the-story-of-javascript-58c85031d8ac/",
                "linkText": "Read the article"
            },
            "hashtag": "#JavaScript #JS #JavaScriptFrameworks",
            "date": "Nov 13 2022",
            "pin": false
        },

        "blogThree": {
            "description": "My perspective on product management",
            "image": "product-management.png",
            "link": {
                "feedLink": "https://medium.com/design-bootcamp/my-perspective-of-product-manager-b094db49d229",
                "linkText": "Read the article"
            },
            "hashtag": "#product-management",
            "date": "Jul 13 2021",
            "pin": false
        }
    }
}
